import { render } from "./Intertexts.vue?vue&type=template&id=fa3613b4&ts=true"
import script from "./Intertexts.vue?vue&type=script&lang=ts"
export * from "./Intertexts.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__